// Quick Buy Fix - Korrigierte finale Version
(function() {
  'use strict';
  
  let isProcessing = false;
  
  // Event Delegation für alle Quick Buy Buttons
  document.addEventListener('click', function(event) {
    const button = event.target.closest('button[aria-controls*="quick-buy-template"]');
    
    if (!button || isProcessing) return;
    
    // Alle Events stoppen
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    isProcessing = true;
    button.setAttribute('aria-busy', 'true');
    
    // Original Button Text speichern
    const originalHTML = button.innerHTML;
    
    // Drawer ID und Handle extrahieren
    const drawerId = button.getAttribute('aria-controls');
    const drawer = document.getElementById(drawerId);
    
    if (drawer && drawer.hasAttribute('handle')) {
      const handle = drawer.getAttribute('handle');
      const variantMatch = handle.match(/variant=(\d+)/);
      
      if (variantMatch) {
        const variantId = variantMatch[1];
        
        // Add to Cart mit Sections für Drawer Update
        const cartDrawerSection = document.querySelector('cart-drawer')?.closest('.shopify-section');
        const sectionId = cartDrawerSection ? cartDrawerSection.id.replace('shopify-section-', '') : null;
        
        const formData = new FormData();
        formData.set('id', variantId);
        formData.set('quantity', '1');
        if (sectionId) {
          formData.set('sections', sectionId);
          formData.set('sections_url', window.location.pathname);
        }
        
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => {
              throw new Error(err.description || 'Fehler beim Hinzufügen');
            });
          }
          return response.json();
        })
        .then(data => {
          // Cart Count und Drawer Content aktualisieren
          updateCartAndDrawer(data, sectionId);
          
          // Erfolgs-Feedback anzeigen
          showSuccessMessage(button, originalHTML);
          
          // Cart Drawer öffnen
          setTimeout(() => openCartDrawer(), 300);
        })
        .catch(error => {
          console.error('Cart Add Error:', error);
          showErrorMessage(button, originalHTML, error.message);
        })
        .finally(() => {
          button.removeAttribute('aria-busy');
          isProcessing = false;
        });
      }
    }
  }, true);
  
  // Cart Count und Drawer Content aktualisieren
  function updateCartAndDrawer(addResponse, sectionId) {
    // Cart laden für aktuelle Counts
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Cart Counts aktualisieren
        const cartCounts = document.querySelectorAll('cart-count, [data-cart-count]');
        cartCounts.forEach(count => {
          if (count.tagName === 'CART-COUNT') {
            count.textContent = cart.item_count;
            count.setAttribute('aria-label', `${cart.item_count} Artikel im Warenkorb`);
          } else if (count.hasAttribute('data-cart-count')) {
            count.textContent = cart.item_count;
          }
        });
        
        // Cart Drawer Content aktualisieren falls Sections vorhanden
        if (addResponse.sections && sectionId && addResponse.sections[sectionId]) {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = addResponse.sections[sectionId];
            const newContent = tempDiv.querySelector('cart-drawer');
            if (newContent) {
              cartDrawer.innerHTML = newContent.innerHTML;
            }
          }
        }
      })
      .catch(err => console.log('Cart update failed:', err));
  }
  
  // Cart Drawer öffnen
  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    
    if (cartDrawer) {
      if (typeof cartDrawer.show === 'function') {
        cartDrawer.show();
      } else {
        cartDrawer.setAttribute('open', '');
      }
    } else {
      // Fallback: Cart Drawer Button klicken
      const cartDrawerButton = document.querySelector('[aria-controls*="cart-drawer"], [data-action="open-drawer"][data-drawer-id*="cart"]');
      if (cartDrawerButton) {
        cartDrawerButton.click();
      }
    }
  }
  
  // Erfolgs-Nachricht anzeigen
  function showSuccessMessage(button, originalHTML) {
    // Button Content ändern aber Structure beibehalten
    const contentDiv = button.querySelector('div:first-child');
    if (contentDiv) {
      const originalText = contentDiv.innerHTML;
      contentDiv.innerHTML = '✓ Hinzugefügt!';
      button.classList.add('button--success');
      
      setTimeout(() => {
        contentDiv.innerHTML = originalText;
        button.classList.remove('button--success');
      }, 2000);
    } else {
      button.innerHTML = '✓ Hinzugefügt!';
      button.classList.add('button--success');
      
      setTimeout(() => {
        button.innerHTML = originalHTML;
        button.classList.remove('button--success');
      }, 2000);
    }
  }
  
  // Fehler-Nachricht anzeigen
  function showErrorMessage(button, originalHTML, errorMsg = 'Fehler') {
    const contentDiv = button.querySelector('div:first-child');
    if (contentDiv) {
      const originalText = contentDiv.innerHTML;
      contentDiv.innerHTML = 'Fehler!';
      button.classList.add('button--error');
      
      setTimeout(() => {
        contentDiv.innerHTML = originalText;
        button.classList.remove('button--error');
      }, 2000);
    } else {
      button.innerHTML = 'Fehler!';
      button.classList.add('button--error');
      
      setTimeout(() => {
        button.innerHTML = originalHTML;
        button.classList.remove('button--error');
      }, 2000);
    }
    
    // Error als Alert anzeigen
    if (errorMsg && errorMsg !== 'Fehler') {
      alert(errorMsg);
    }
  }
  
  // Quick Buy Drawers beim Laden verstecken
  document.addEventListener('DOMContentLoaded', function() {
    const drawers = document.querySelectorAll('[id*="quick-buy-template"]');
    drawers.forEach(drawer => {
      drawer.style.display = 'none';
      drawer.setAttribute('hidden', '');
      drawer.setAttribute('inert', '');
    });
  });
  
})();